import { useTranslation } from 'react-i18next'

import { formatMoney } from '../../../../../helpers/helpers'

interface TicketProps {
  ticket: { name: string; price: number | string; description: string }
}

export const Ticket = ({ ticket }: TicketProps) => {
  const { t } = useTranslation(['eventManagement'])
  const priceToDisplay =
    ticket.price && parseFloat(ticket.price.toString())
      ? formatMoney(ticket.price)
      : t('eventManagement:common.free')

  return (
    <div className="ticket">
      <div>
        <span className="ticket__name">{ticket.name}</span>
        <span className="ticket__price">{priceToDisplay}</span>
      </div>
      {ticket.description && <p className="ticket__description">{ticket.description}</p>}
    </div>
  )
}
